import { render, staticRenderFns } from "./WaitingPlayer.vue?vue&type=template&id=5d66f2ad&scoped=true&"
import script from "./WaitingPlayer.vue?vue&type=script&lang=js&"
export * from "./WaitingPlayer.vue?vue&type=script&lang=js&"
import style0 from "./WaitingPlayer.vue?vue&type=style&index=0&id=5d66f2ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66f2ad",
  null
  
)

export default component.exports